"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.findLastIndex = exports.formatDate = exports.getUuid = exports.arrToMap = exports.transformResult = exports.handleProcessUrlQuery = exports.getCommonHeaders = exports.getBaseUrlV5 = exports.setBaseUrlV5 = exports.getBaseUrl = exports.setBaseUrl = exports.getSecondLevelDomain = exports.genAIRequestId = exports.getParams = void 0;
var common_file_1 = __importDefault(require("../plugins/file/common-file"));
var base_1 = __importDefault(require("../plugins/base"));
var helper_factory_1 = __importDefault(require("../plugins/helper/helper-factory"));
var constant_1 = require("./constant");
// 获取url的参数
var getParams = function (url) {
    if (!url) {
        return {};
    }
    var params = {};
    var parser = document.createElement('a');
    parser.href = url;
    var query = parser.search.substring(1);
    if (query) {
        var vars = query.split('&');
        for (var i = 0; i < vars.length; i++) {
            var _a = vars[i].split('='), key = _a[0], _b = _a[1], val = _b === void 0 ? '' : _b;
            params[key] = decodeURIComponent(val);
        }
    }
    return params;
};
exports.getParams = getParams;
var random = function (num) {
    var res = '';
    for (var i = 0; i < num; i++) {
        res += parseInt((10 * Math.random()));
    }
    return res;
};
/**
 * 已废弃，后续使用 commonHelper.getDeviceId() 代替
 * @deprecated
 */
var deviceId = random(6);
var query = (0, exports.getParams)(window.location.href) || {};
//@ts-ignore
var clientType = query.clientType || '';
/**
 * 已废弃，后续使用 commonHelper.genClientRequestId() 代替
 * @deprecated
 */
var genAIRequestId = function () {
    return "".concat(new Date().getTime(), "_").concat(deviceId, "_").concat(random(12));
};
exports.genAIRequestId = genAIRequestId;
var getHeaderProduct = function () {
    if (base_1.default.isKdocs) {
        return 'KDOCS';
    }
    return clientType.indexOf('kdocs') > -1 ? 'KDOCS' : 'WPS';
};
var getSecondLevelDomain = function () {
    var hostname = window.location.hostname || '';
    var parts = hostname.split('.');
    if (parts.length > 2) {
        parts.shift();
    }
    return parts.join('.');
};
exports.getSecondLevelDomain = getSecondLevelDomain;
var baseUrl = '';
var setBaseUrl = function (url) {
    baseUrl = url;
};
exports.setBaseUrl = setBaseUrl;
var getBaseUrl = function () {
    var _a;
    if (baseUrl) {
        return baseUrl;
    }
    // 处理私有化
    if ((_a = window.__CONFIG__) === null || _a === void 0 ? void 0 : _a.pathPrefix) {
        return window.location.origin + window.__CONFIG__.pathPrefix;
    }
    var tempDomain = (0, exports.getSecondLevelDomain)();
    if (tempDomain && (tempDomain.includes('wps.cn') || tempDomain.includes('kdocs.cn'))) {
        return "https://copilot-api.".concat(tempDomain);
    }
    // B环境
    // return 'https://copilot-api-b.wps.cn'
    return 'https://copilot-api.wps.cn';
};
exports.getBaseUrl = getBaseUrl;
var baseUrlV5 = '';
var setBaseUrlV5 = function (url) {
    baseUrlV5 = url;
};
exports.setBaseUrlV5 = setBaseUrlV5;
var getBaseUrlV5 = function () {
    var _a;
    if (baseUrlV5) {
        return baseUrlV5;
    }
    // 处理私有化
    if ((_a = window.__CONFIG__) === null || _a === void 0 ? void 0 : _a.pathPrefix) {
        return window.location.origin + window.__CONFIG__.pathPrefix;
    }
    // 兼容插件2.0
    if (window.Extention) {
        return "".concat(constant_1.HTTPS).concat(constant_1.DOMAIN_API_WPS);
    }
    var tempDomain = (0, exports.getSecondLevelDomain)();
    if (tempDomain.includes('kdocs.cn')) {
        return window.location.origin;
    }
    return "".concat(constant_1.HTTPS).concat(constant_1.DOMAIN_API_WPS);
};
exports.getBaseUrlV5 = getBaseUrlV5;
var getCommonHeaders = function () {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    var version = require('../../package.json').version;
    return {
        'X-Client-Type': 'kdocs-web', // TODO: 待完善
        'X-Component': common_file_1.default.getOfficeType(),
        'X-Client-Ver': version,
        'x-client-chan': version,
        'x-device-id': helper_factory_1.default.getDeviceId(),
        'x-client-lang': 'zh',
        'x-product': getHeaderProduct(), // TODO: 待完善
        'Content-Type': 'application/json'
    };
};
exports.getCommonHeaders = getCommonHeaders;
var handleProcessUrlQuery = function () {
    var search = window.location.search;
    if (search) {
        var params = new URLSearchParams(search);
        return Object.fromEntries(params);
    }
    return undefined;
};
exports.handleProcessUrlQuery = handleProcessUrlQuery;
function transformResult(res) {
    return res && res.code ? res.result : {};
}
exports.transformResult = transformResult;
/**
 * 将数组转化为map映射表，通过数组内某个key来取值
 */
var arrToMap = function (arr, key) {
    if (key === void 0) { key = 'id'; }
    if (Array.isArray(arr)) {
        var ret = {};
        var _loop_1 = function (item) {
            if (key.includes('.')) {
                var keys = key.split('.');
                var _k_1 = item;
                keys.forEach(function (i) {
                    _k_1 = _k_1[i];
                });
                ret[_k_1] = item;
            }
            else {
                ret[item[key]] = item;
            }
        };
        for (var _i = 0, arr_1 = arr; _i < arr_1.length; _i++) {
            var item = arr_1[_i];
            _loop_1(item);
        }
        return ret;
    }
    else {
        return {};
    }
};
exports.arrToMap = arrToMap;
/**
 * 获取32位字符串uuid
 */
var getUuid = function () {
    function e() {
        return ((65536 * (1 + Math.random())) | 0).toString(16).substring(1);
    }
    return e() + e() + e() + e() + e() + e() + e() + e();
};
exports.getUuid = getUuid;
var formatDate = function (date, format) {
    var year = date.getFullYear().toString();
    var month = ('0' + (date.getMonth() + 1)).slice(-2).toString();
    var day = ('0' + date.getDate()).slice(-2).toString();
    var hour = ('0' + date.getHours()).slice(-2).toString();
    var minute = ('0' + date.getMinutes()).slice(-2).toString();
    return format.replace('YYYY', year).replace('MM', month).replace('DD', day).replace('HH', hour).replace('mm', minute);
};
exports.formatDate = formatDate;
// lodash的findLastIndex方法
var findLastIndex = function (array, predicate) {
    var index = array.length;
    while (index--) {
        if (predicate(array[index])) {
            return index;
        }
    }
    return -1;
};
exports.findLastIndex = findLastIndex;
